import { chunkArray } from '../utils/utils';
import { makeRequest, buildOptions } from './ServiceHelpers';

const endpointUrl = process.env.REACT_APP_PRICE_INTEGRATION_URL;
const batchSize = 40;
export const pricingArchOldVersion = 'v1';
export const accountIdClaimName = 'https://claims.cimpress.io/account';

export const getPricingArchVersion = async accountId => {
  const options = buildOptions();
  const promise = makeRequest(
    endpointUrl,
    `/v1/accountPricingArchitecture/${accountId}`,
    options,
    'getting pricing version by account Id'
  );
  const response = await promise;
  if (!response) {
    return pricingArchOldVersion;
  } else {
    const pricingArchVersionIfno = response.filter(pricingVersion => pricingVersion.priceType === 'transferPrice');
    if (pricingArchVersionIfno && pricingArchVersionIfno.length > 0) {
      return pricingArchVersionIfno[0].arch;
    } else {
      return pricingArchOldVersion;
    }
  }
};

export const getRequiredInputsForItems = async mcpSkus => {
  const options = buildOptions();

  const mcpSkusBatches = chunkArray(mcpSkus, batchSize);
  const requiredInputsBySku = {};

  for (const batch of mcpSkusBatches) {
    const responses = await Promise.all(
      batch.map(mcpSku =>
        makeRequest(endpointUrl, `v1/requiredInputs/${mcpSku.sku}`, options, 'getting required inputs for a sku')
      )
    );

    batch.forEach(({ sku }, index) => {
      requiredInputsBySku[sku] = responses[index];
    });
  }

  return requiredInputsBySku;
};
